import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const STATUS_META = {
  draft:        { label: 'Bozza',          cls: 'badge-gray' },
  submitted:    { label: 'In valutazione', cls: 'badge-amber' },
  under_review: { label: 'In revisione',   cls: 'badge-amber' },
  certified:    { label: 'Certificato',    cls: 'badge-green' },
  rejected:     { label: 'Non approvato',  cls: 'badge-red' },
};

const LEVEL_META = {
  1: { label: 'Livello 1 — Base',       emoji: '🥉' },
  2: { label: 'Livello 2 — Avanzato',   emoji: '🥈' },
  3: { label: 'Livello 3 — Eccellenza', emoji: '🥇' },
};

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/projects').then(r => setProjects(r.data)).finally(() => setLoading(false));
  }, []);

  const stats = {
    total: projects.length,
    certified: projects.filter(p => p.status === 'certified').length,
    inReview: projects.filter(p => ['submitted', 'under_review'].includes(p.status)).length,
    drafts: projects.filter(p => p.status === 'draft').length,
  };

  return (
    <>
      <div className="topbar">
        <span className="topbar-title">I miei progetti</span>
        <Link to="/dashboard/new-project" className="btn btn-primary btn-sm">+ Nuovo progetto</Link>
      </div>
      <div className="page-content">
        {/* Stats */}
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-label">Progetti totali</div><div className="stat-value">{stats.total}</div></div>
          <div className="stat-card"><div className="stat-label">Certificati</div><div className="stat-value" style={{ color: '#1D9E75' }}>{stats.certified}</div></div>
          <div className="stat-card"><div className="stat-label">In valutazione</div><div className="stat-value" style={{ color: '#854F0B' }}>{stats.inReview}</div></div>
          <div className="stat-card"><div className="stat-label">Bozze</div><div className="stat-value">{stats.drafts}</div></div>
        </div>

        {/* List */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#9B9A92' }}>Caricamento...</div>
        ) : projects.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: 48 }}>
            <div style={{ fontSize: 40, marginBottom: 14 }}>📁</div>
            <h3 style={{ marginBottom: 8 }}>Nessun progetto ancora</h3>
            <p style={{ color: '#5C5B55', marginBottom: 20 }}>Aggiungi il tuo primo software per avviare la certificazione ESG.</p>
            <Link to="/dashboard/new-project" className="btn btn-primary">+ Aggiungi progetto</Link>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {projects.map(p => {
              const sm = STATUS_META[p.status] || STATUS_META.draft;
              const lm = p.certificationLevel ? LEVEL_META[p.certificationLevel] : null;
              const isDraft = p.status === 'draft';
              return (
                <Link key={p.id} to={`/dashboard/projects/${p.id}`} style={{ textDecoration: 'none' }}>
                  <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer', borderStyle: isDraft ? 'dashed' : 'solid' }}>
                    <div style={{ width: 40, height: 40, borderRadius: 10, background: isDraft ? '#F0EFE8' : '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                      {isDraft ? '📝' : '💻'}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 500, color: '#1A1A18', marginBottom: 2 }}>{p.name}</div>
                      <div style={{ fontSize: 12, color: '#9B9A92' }}>
                        {p.company?.name}
                        {p.submittedAt && ` · Inviato il ${new Date(p.submittedAt).toLocaleDateString('it-IT')}`}
                        {p.scoreTotal > 0 && ` · ESG: ${p.scorePercentage != null ? Math.round(p.scorePercentage) : Math.round((p.scoreTotal / 125) * 100)}%`}
                      </div>
                    </div>
                    {lm && <span className="badge badge-green">{lm.emoji} {lm.label}</span>}
                    <span className={`badge ${sm.cls}`}>{sm.label}</span>
                    {isDraft && <span style={{ fontSize: 13, color: '#1D9E75', fontWeight: 500, flexShrink: 0 }}>Continua →</span>}
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
